import React, { useCallback, useMemo,} from "react";

import { retailerTableColumnsConfig } from "./retailerTableColumnsConfig";
import { Table } from "../../../component/table/Table";

import { useNavigate } from "react-router-dom";

export const RetailerTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (rowData) => {
      console.log(rowData);

      navigate(`${rowData.id}`);
    },

    [navigate]
  );
  const columnDefs = useMemo(
    () => retailerTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail]
  );

  return <Table data={data} columns={columnDefs} />;
};
